import {DetailedProps, join} from '../../utils';
import {DataType} from 'csstype';
import {forwardRef} from 'react';
import {Box} from '../box/box';
import styles from './flex-box.module.less';

export type FlexBoxProps = {
	direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse',
	justify?: 'start' | 'center' | 'end' | DataType.ContentDistribution;
	align?: 'center' | 'end' | 'start' | 'self-end' | 'self-start' | 'stretch';
	wrap?: 'wrap' | 'nowrap';
	// style?: Omit<CSSStyleDeclaration, 'flexDirection' | 'justifyContent' | 'alignContent' | 'display'>
// } & Omit<DetailedProps<HTMLDivElement>, 'style'>;
} & DetailedProps<HTMLDivElement>;

export const FlexBox = forwardRef<HTMLDivElement, FlexBoxProps>((
	{
		direction,
		justify,
		align,
		style,
		wrap,
		...props
	}, ref) => <Box {...props}
                    style={style as any}
                    ref={ref}
                    className={join(
	                    props.className,
	                    styles.flex,
	                    direction ? styles['direction-' + direction] : '',
	                    justify ? styles['justify-' + justify] : '',
	                    align ? styles['align-' + align] : '',
	                    wrap ? styles['wrap-' + wrap] : '',
                    )}/>
);

export default FlexBox;
